<!-- 发票提取单据 -->
<template>
	<div v-loading.fullscreen.lock="fullscreenLoading">
		<!-- 表格 -->
		<el-table ref="moviesTable" height="420" size="mini" style="width: 100%" :data="mainData" border stripe
			highlight-current-row :header-cell-style="getHeaderCellStyle" @selection-change="mainSelectionChange">
			<el-table-column type="selection" width="50"></el-table-column>
			<el-table-column align="center" min-width="120" prop="psomId" label="采购订单" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column align="center" min-width="120" prop="opmName" label="业务员名字" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column align="center" min-width="120" prop="depName" label="业务部门" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column align="center" min-width="120" prop="smName" label="购进单位" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column align="center" min-width="120" prop="salesName" label="供应商业务员"
				:show-overflow-tooltip="true"></el-table-column>
			<el-table-column align="center" min-width="120" prop="totalNumber" label="总数量"
				:show-overflow-tooltip="true"></el-table-column>
			<el-table-column align="center" min-width="120" prop="totalMoney" label="总金额" :show-overflow-tooltip="true">
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination v-if="isPagination" @size-change="handleSizeChange" @current-change="handleCurrentChange"
			:current-page="currentPage" :page-sizes="pageSizes" background :page-size="pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total="total">
		</el-pagination>
		<el-collapse v-model="activeName" accordion>
			<el-collapse-item name="1" :disabled="true">
				<template slot="title">
					<!-- <el-switch style="display: block" @change="showDetailChange" v-model="showdetail" active-text="展示明细" inactive-text="关闭明细">
          </el-switch> -->
					<el-button v-if="isDetail" size="mini" @click="sureDetail" style="margin-left: 60px" type="primary">
						确认选择</el-button>
					<!-- <el-tag v-else size="mini" style="margin-left: 60px">明细表格</el-tag> -->
				</template>
				<!-- 明细表 -->
				<!-- <el-table size="mini" height="280" :data="detailData" border stripe highlight-current-row :header-cell-style="getHeaderCellStyleD" style="width: 100%">
          <el-table-column align="center" min-width="120" prop="wobkedId" label="销售出库记账ID" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column align="center" min-width="120" prop="bgmName" label="通用名称" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column align="center" min-width="120" prop="prodate" label="生产日期" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span v-if="scope.row.prodate">
                {{ $common.getLocalTime(item.prodate) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column align="center" min-width="120" prop="expidate" label="有效期" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span v-if="scope.row.expidate">
                {{ $common.getLocalTime(item.expidate) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column align="center" min-width="120" prop="outRate" label="销项税率" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column align="center" min-width="120" prop="price" label="单价" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column align="center" min-width="120" prop="money" label="金额" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column align="center" min-width="120" prop="psprice" label="含税价格" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column align="center" min-width="120" prop="psmoney" label="含税金额" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column align="center" min-width="120" prop="treatCount" label="待开票数量" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column align="center" min-width="120" prop="batchno" label="批号" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column align="center" min-width="120" prop="sterBatchno" label="灭菌批号" :show-overflow-tooltip="true"></el-table-column>
        </el-table> -->
			</el-collapse-item>
		</el-collapse>
	</div>
</template>

<script>
	export default {
		name: "SearchSchemeordeunloading",
		components: {},
		data() {
			return {
				opmId: "",
				ormId: "",
				activeName: "1", //默认展开
				showdetail: true,
				detailData: [],
				currentPage: 1,
				pageSizes: [10, 25, 50, 100],
				pageSize: 10,
				total: 0,
				mainData: [],
				selectedDataIndexList: [],
				isPagination: "",
				searchTermList: [], //检索条件
				Columns: [],
				ColumnsDetail: [],
				isDetail: false,
				multipleSelection: [], //数组内层
				queryMap: {
					cmId: "",
					cmName: "",
					end: "",
					opmId: "",
					opmName: "",
					start: "",
				},
				returnObj: {
					//外层对象数据
					mainData: [],
					detailData: [],
				},
				fullscreenLoading: false
			};
		},

		props: {
			invoiceExtractData: {
				type: Object,
				require: true,
			},
		},
		watch: {},
		computed: {},
		mounted() {},
		created() {
			this.fullscreenLoading = true
			// 处理组件需要的数据
			this.opmId = JSON.parse(sessionStorage.getItem("userInfo")).opmId;
			this.getTableMainList();
		},
		methods: {
			//明细隐藏
			showDetailChange(e) {
				e == true ? (this.activeName = "1") : (this.activeName = "0");
			},
			// 切换显示条数
			setDataPageSize(val) {
				this.getRequestData.page = 1;
				this.getRequestData.rows = val;
				this.getTableMainList();
			},

			//主单选择
			mainSelectionChange(val) {
				console.log(val);
				this.returnObj.mainData = JSON.parse(JSON.stringify(val));
				this.selectedDataIndexList = [];
				val.forEach((v) => {
					this.selectedDataIndexList.push(v.psomId);
				});

				this.selectedDataIndexList.length > 0 && this.getTableDetailList();
			},
			//确认选择
			sureDetail() {
				this.returnObj.detailData = JSON.parse(JSON.stringify(this.detailData));
				this.$emit("invoiceExtractMethods", this.returnObj);
			},
			// 获取主表格
			async getTableMainList() {
				let res = await this.$http.unloadqueryOrder(this.queryMap);
				console.log(res);
				this.mainData = res.result.list;
				this.fullscreenLoading = false
				//   if (res.status == 200) {
				//     this.mainData = res.result; //默认第一条
				//   } else {
				//     this.$message({
				//       message: res.message,
				//       type: "error",
				//     });
				//     this.$emit("invoiceExtractMethods", "");
				//     return false;
				//   }
			},
			// 获取明细表格
			async getTableDetailList() {
				let res = await this.$http.transportdocquerydetail({
					ids: this.selectedDataIndexList,
				});
				this.detailData = res;
				this.isDetail = this.mainData.length > 0 ? true : false;
				console.log(res);
				//   if (res && res.status == 200) this.detailData = res.result;
				//   this.isDetail = this.detailData.length > 0 ? true : false;
			},
			//分页
			handleSizeChange(val) {
				this.pageSize = val;
				//   this.invoiceExtractData.rows = val;
				this.getTableMainList();
			},
			// 分页
			handleCurrentChange(val) {
				this.currentPage = val;
				//   this.invoiceExtractData.page = val;
				this.getTableMainList();
			},
			//   -----------------------------------------------------
			getHeaderCellStyle() {
				return "background: skybule; borderBottom: solid 1px #5a5e66;color: #3e5569";
			},
			getHeaderCellStyleD() {
				return "background: skybule;color: #3e5569";
			},
		},
	};
</script>

<style scoped>
	.el-pagination {
		padding: 20px 0px 5px;
	}
</style>